export const Images = {
    ImagesHome: [
        {
            id: 1,
            img: require("../assets/img/trivella-1.jpeg"),
        },
        {
            id: 2,
            img: require("../assets/img/trivella-2.jpeg"),
        },
        {
            id: 3,
            img: require("../assets/img/trivella-3.jpeg"),
        },
        {
            id: 4,
            img: require("../assets/img/trivella-4.jpeg"),
        },
        {
            id: 5,
            img: require("../assets/img/trivella-5.jpeg"),
        },
        {
            id: 6,
            img: require("../assets/img/trivella-6.jpg"),
        },
        {
            id: 7,
            img: require("../assets/img/trivella-7.jpg"),
        },
        {
            id: 8,
            img: require("../assets/img/trivella-8.jpg"),
        },
        {
            id: 9,
            img: require("../assets/img/trivella-9.jpg"),
        },
        {
            id: 10,
            img: require("../assets/img/trivella-10.jpg"),
        },
        {
            id: 11,
            img: require("../assets/img/trivella-11.jpg"),
        },
        {
            id: 12,
            img: require("../assets/img/trivella-12.jpg"),
        },
        {
            id: 13,
            img: require("../assets/img/trivella-13.jpg"),
        },
        {
            id: 14,
            img: require("../assets/img/trivella-14.jpg"),
        },
        {
            id: 15,
            img: require("../assets/img/trivella-15.jpg"),
        },
        {
            id: 16,
            img: require("../assets/img/trivella-16.jpg"),
        },
        {
            id: 17,
            img: require("../assets/img/trivella-17.jpg"),
        },
        {
            id: 18,
            img: require("../assets/img/trivella-18.jpg"),
        },
        {
            id: 19,
            img: require("../assets/img/trivella-19.jpg"),
        },
        {
            id: 20,
            img: require("../assets/img/trivella-20.jpeg"),
        }, 
        {
            id: 21,
            img: require("../assets/img/trivella-21.jpg"),
        }, 
        {
            id: 22,
            img: require("../assets/img/trivella-22.jpg"),
        }, 
        {
            id: 28,
            img: require("../assets/img/trivella-28.jpg"),
        }, 
        {
            id: 29,
            img: require("../assets/img/trivella-29.jpg"),
        }, 
    ],
}

